import { MenuItem, Position } from "@blueprintjs/core"
import { Suggest } from "@blueprintjs/select"
import { debounce } from "lodash-es"
import React, { useCallback, useState } from "react"
import formatAddress from "utils/googleMaps"
import CustomButton from "../../Atoms/CustomButton"
import { withFormController } from "../../Molecules/FormController"
const CustomAutoComplete = ({ onChange, path, disabled }) => {
  const autoComplete = new window.google.maps.places.AutocompleteService()
  const sessionToken = new window.google.maps.places.AutocompleteSessionToken()
  const geocoder = new window.google.maps.Geocoder()
  const [query, setQuery] = useState("")
  const [item, setItem] = useState(null)
  const [items, setItems] = useState([])

  function handleSearch(query) {
    if (query && query.length > 2) {
      autoComplete.getPlacePredictions(
        {
          componentRestrictions: { country: ["in"] },
          input: query,
          sessionToken: sessionToken,
        },
        places => setItems(places)
      )
    }
  }

  // Use a debouncer to limit the api calls and pass in an empty array of dependencies to render it only once
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handler = useCallback(debounce(handleSearch, 300), [])
  function handleChange(query) {
    setQuery(query)
    handler(query)
  }

  return (
    <Suggest
      disabled={disabled}
      className="vt-places-autocomplete-suggest"
      items={items ?? []}
      query={query}
      inputValueRenderer={item => {
        const mainText = item?.structured_formatting?.main_text ?? ""
        return mainText
      }}
      itemRenderer={(item, { handleClick, modifiers }) => (
        <MenuItem
          active={modifiers.active}
          onClick={handleClick}
          icon="locate"
          className="text-sm"
          key={item?.id}
          text={item?.description}
        />
      )}
      onItemSelect={item => {
        if (item?.place_id) {
          geocoder.geocode({ placeId: item.place_id, region: "IN" }, res => {
            const response = res?.[0]
            const addr = formatAddress(response.address_components)
            const address = response.formatted_address
            const coords = response.geometry.location.toJSON()
            onChange(path, {
              ...addr,
              address,
              latitude: coords?.lat,
              longitude: coords?.lng,
            })
          })
        }
        setItem(item)
      }}
      selectedItem={item}
      inputProps={{
        leftIcon: "search",
        fill: true,
        rightElement: (
          <CustomButton
            onClick={e => {
              setQuery("")
              setItem(null)
            }}
            disabled={disabled}
            icon="cross"
          />
        ),
      }}
      type="text"
      value={query}
      onQueryChange={handleChange}
      noResults={<MenuItem text="No Places Found,Try changing the search" />}
      popoverProps={{
        popoverClassName: "vt-autocomplete-popover",
        position: Position.BOTTOM_LEFT,
        minimal: true,
      }}
    />
  )
}

export default withFormController(CustomAutoComplete)
